import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=2f81bf62&scoped=true&"
import script from "./Transactions.vue?vue&type=script&lang=js&"
export * from "./Transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81bf62",
  null
  
)

export default component.exports